import { ENV_CONSTS } from './env-consts.ts';
import { runtimeConfig } from './runtime-config.ts';
import { TranslationKey } from './i18n.ts';

export const devMode = import.meta.env.DEV;
export const b2cVersion = ENV_CONSTS.SITE_TYPE === 'b2c';
export const b2bVersion = !b2cVersion;

const KNOWN_OPERATORS = ['fomo', 'dafabet'] as const;
type KnownOperator = (typeof KNOWN_OPERATORS)[number];

const OPERATOR_LOBBY_NAMES: Record<KnownOperator, string> = {
  fomo: 'fomo.io',
  dafabet: 'Dafabet',
};

export function operatorFromHostname(hostname?: string): KnownOperator | null {
  const host = (
    hostname ??
    (typeof window !== 'undefined' ? window.location.hostname : '')
  )
    .toLowerCase()
    .split(':')[0];
  const label = host.split('.')[0];
  const candidates = [label];
  if (label.startsWith('demo-')) {
    candidates.push(label.slice('demo-'.length));
  }

  for (const candidate of candidates) {
    if ((KNOWN_OPERATORS as readonly string[]).includes(candidate)) {
      return candidate as KnownOperator;
    }
  }

  return null;
}

export function getB2BLobbyName(): string | null {
  if (runtimeConfig.lobbyName) {
    return runtimeConfig.lobbyName;
  }

  const operator = runtimeConfig.operator || operatorFromHostname();
  if (!operator) {
    return null;
  }

  return (KNOWN_OPERATORS as readonly string[]).includes(operator)
    ? OPERATOR_LOBBY_NAMES[operator as KnownOperator]
    : operator;
}

function sameOriginApis() {
  const restAPI = '/api/';
  if (typeof window === 'undefined') {
    return { restAPI, wsAPI: '/prices' };
  }

  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  return {
    restAPI,
    wsAPI: `${protocol}//${window.location.host}/prices`,
  };
}

export const appConfig = b2cVersion
  ? {
      restAPI: ENV_CONSTS.B2C_REST_API || sameOriginApis().restAPI,
      wsAPI: ENV_CONSTS.B2C_WS_API || sameOriginApis().wsAPI,
    }
  : sameOriginApis();

export const links = {
  exclusiveTournament:
    'https://coinraces.medium.com/coinraces-crdao-genesis-launch-exclusive-tournament-1-000-virtual-prize-ffae52248c60',
  howToPlay: 'https://coinraces.gitbook.io/coinraces/game/how-does-it-work',
  about: 'https://coinraces.io/about',
  refer: 'https://coinraces.io/refer',
  discord: 'https://discord.com/invite/ApPmbDCj3m',
} as const;

export const socialLinks = {
  twitter: 'https://x.com/CoinRacesGame',
  telegram: 'https://t.me/coinraces',
} as const;

export type SocialLinkName = keyof typeof socialLinks;

export const referralUrlParam = 'refcode';

export const menuLinks: Array<{
  label: TranslationKey;
  href: (typeof links)[keyof typeof links];
}> = [
  {
    label: 'HEADER_MENU__howToPlayLink',
    href: links.howToPlay,
  },
  {
    label: 'HEADER_MENU__aboutLink',
    href: links.about,
  },
];
